export const img = (path) => `/img/${path}`;

export const productGroups = [
  {
    key: 'horizontal-balers',
    title: 'Horizontal Balers',
    description: 'Manual tie, automatic tie, wide-mouth, and full-eject horizontal balers for industrial production.',
    art: 'equipment/horizontal-balers/closed-vs-open-vs-gate.jpg',
    items: [
      ['closed-end-manual-tie-balers', 'Closed-End Manual Tie Balers', 'Horizontal closed-end semi-automatic balers with vertical infeed chutes, wide-mouth hoppers, cart dumping systems, pre-press chambers, and medium to extra heavy-duty configurations.', 'equipment/horizontal-balers/feed-hopper.jpg', ['30 inch, 42 inch, and 46 inch hopper options', 'Manual tie wire or strap operation', 'Industrial and commercial applications']],
      ['open-end-automatic-tie-balers', 'Open-End Automatic Tie Balers', 'Automatic tying horizontal open-end balers for medium and high production baling of paper, corrugated, box board trim, non-wovens, fiberglass, aluminum beverage containers, and industrial by-products.', 'equipment/horizontal-balers/horizontal-3.jpg', ['Dependable wire inserting and tying mechanism', 'Independent electric and hydraulic systems', 'Simple adjustments and servicing']],
      ['wide-mouth-open-end-automatic-tie-balers', 'Wide-Mouth Open-End Automatic Tie Balers', 'Large-opening automatic tie balers for bulky materials, higher infeed volumes, and applications that need more room for material to fall freely into the baling chamber.', 'equipment/horizontal-balers/horizontal-8.jpg', ['Extra wide-mouth feed openings', 'Automatic tying for higher throughput', 'Useful for large or irregular material streams']],
      ['multi-materials-full-eject-closed-end-balers', 'Multi Materials Full-Eject Closed-End Balers', 'Full-eject balers for multigrade materials, cotton and textile fibers, thin films, shredded carpet, foam rubber, fiberglass, and other difficult-to-bale materials.', 'equipment/horizontal-balers/hopper.jpg', ['100 percent separation of each bale', 'Full bale ejection after tying', 'Strong fit for changing materials']],
      ['open-end-manual-tie-balers', 'Open-End Manual Tie Balers', 'Manual tie horizontal open-end balers for lower-cost low and medium production baling of paper, corrugated, non-wovens, aluminum beverage containers, and industrial trimmings.', 'equipment/horizontal-balers/horizontal-0.jpg', ['Open-end extrusion chamber resistance', 'Lower-cost horizontal production', 'Common manual tie option']],
    ],
  },
  {
    key: 'material-handling',
    title: 'Material Handling',
    description: 'Cart lifters, dumpers, conveyors, bale conveying, and bagging systems for moving material into and out of balers.',
    art: 'equipment/conveyors-material-handling/conveyor-2.jpg',
    items: [
      ['cart-lifters-dumpers-dump-carts', 'Cart Lifters, Dumpers & Dump Carts', 'Cart lifters and dumpers speed up cart unloading, reduce manual handling, and integrate with C&M baler power units or independent hydraulic packages.', 'equipment/custom-specialty-equipment/custom-specialty-equipment-1.jpg', ['Integrated or independently powered systems', 'Safety guards and interlocks', 'Steel and molded plastic dump cart options']],
      ['conveyors-bale-conveying-bagging-systems', 'Conveyors, Bale Conveying & Bagging Systems', 'Material handling belt conveyors, bale conveyors, and custom bagging systems designed around how material is collected, loaded, discharged, and shipped.', 'equipment/conveyors-material-handling/conveyor-2.jpg', ['Baler loading conveyors', 'Bale take-away systems', 'Custom bagging and downstream handling']],
    ],
  },
  {
    key: 'specialty-baling',
    title: 'Specialty Baling',
    description: 'Balers for textiles, used clothing, cotton gin waste, biomass, vertical applications, and custom machinery.',
    art: 'equipment/horizontal-balers/textiles.jpg',
    items: [
      ['used-clothing-balers', 'Used Clothing Balers', 'Balers for used clothing and textile materials where springback, bale handling, and manual sorting patterns shape the equipment recommendation.', 'equipment/horizontal-balers/horizontal-5.jpg', ['Textile and apparel recycling', 'Difficult-to-compress fibers', 'Works with full-eject recommendations']],
      ['cotton-gin-textile-baling-presses', 'Cotton Gin & Textile Baling Presses', 'Baling presses for cotton, tobacco, textile goods, manmade fibers, and natural fibers with special attention to contamination control and bale consistency.', 'equipment/horizontal-balers/textiles.jpg', ['Cotton and textile fiber applications', 'Natural and manmade fiber handling', 'Special compression platen options']],
      ['biomass-cotton-gin-trash-baling-press', 'Biomass & Cotton Gin Trash Baling Press', 'The C&M2424EC cotton gin trash and biomass baling press was developed after years of trials to bale organic waste from cotton ginning and mote processing operations.', 'equipment/horizontal-balers/biomass.jpg', ['40 HP hydraulic power unit', 'PLC controlled operator panel', 'Bales cotton gin waste, bagasse, Miscanthus, and other energy crops']],
      ['vertical-down-packing-baling-presses-balers', 'Vertical & Down-Packing Baling Presses & Balers', 'Vertical down-stroke balers and specialty down-packing presses with front loading, rear loading, hydraulic bale eject, high compression force, and custom bale sizes.', 'equipment/vertical-balers/vertical-3.jpg', ['Common mill-size bale formats', 'Low-volume and special material applications', 'Heavy-duty and specialty C&M models']],
      ['custom-designed-specialty-balers', 'Custom Designed & Specialty Balers', 'Custom baling presses for unique applications, special features, difficult materials, and facilities where a standard baler cannot solve the full material handling problem.', 'equipment/custom-specialty-equipment/custom-specialty-equipment-1.jpg', ['Built for unusual applications', 'Custom loading and discharge options', 'Standard C&M engineering foundation']],
    ],
  },
  {
    key: 'waste-reduction',
    title: 'Waste Reduction',
    description: 'Compactors and waste handling systems that increase payloads, reduce container pulls, and support cleaner operations.',
    art: 'equipment/compactors/compactors.jpg',
    items: [
      ['precrush-compactors-waste-compactors', 'PreCrush Compactors & Waste Compactors', 'PreCrush compactors and waste compactors increase waste container loads, reduce paid trips to the landfill, and help facilities manage bulky disposal streams.', 'equipment/compactors/precrush-compactor.jpg', ['Pre-crushes bulky loads before compaction', 'Reduces landfill hauling trips', 'Custom waste handling configurations']],
    ],
  },
];

export const products = productGroups.flatMap((group) =>
  group.items.map(([slug, title, summary, image, highlights]) => ({
    slug,
    title,
    summary,
    image,
    highlights,
    group: group.title,
    groupKey: group.key,
    section: 'Products',
  }))
);

export const guidePages = [
  ['horizontal-manual-tie-balers', 'Horizontal Manual Tie Balers', 'Manual tie horizontal balers are efficient, easy to load, and often used for 1,000 to 5,000 pounds per hour depending on material and loading method.', 'equipment/horizontal-balers/horizontal-0.jpg', ['Closed-end, open-end, and full-eject styles', 'Operator inserts and locks bale ties', 'Hopper opening and compression force are critical']],
  ['horizontal-automatic-tie-balers', 'Horizontal Automatic Tie Balers', 'Automatic tie balers are recommended when a regular baler operator is not available or when volume exceeds roughly three tons per hour for many materials.', 'equipment/horizontal-balers/horizontal-3.jpg', ['Higher production operation', 'Automatic wire tying', 'Best when material flow is steady']],
  ['multi-material-full-eject-balers', 'Multi-Material Full Eject Balers', 'Full-eject balers push the finished bale completely out of the chamber and provide clean separation when baling multiple grades or difficult material types.', 'equipment/horizontal-balers/hopper.jpg', ['Excellent for multigrade recycling', 'Useful for foam, fibers, carpet, and films', 'Commonly uses 30 HP or 40 HP power units']],
  ['vertical-down-packing-balers', 'Vertical & Down-Packing Balers', 'Vertical down-stroke balers are common because of their lower cost and versatility, especially for lower volumes of cardboard, paper, and packaging material.', 'equipment/vertical-balers/vertical-3.jpg', ['Common 60 x 30 x 48 inch mill-size bales', '5 HP to 15 HP common power unit range', 'Heavy-duty C&M models can include bale eject and rear loading']],
].map(([slug, title, summary, image, highlights]) => ({ slug, title, summary, image, highlights, section: 'Selection Guide' }));

export const servicePages = [
  ['service-department', 'Service Department', 'C&M supports baler service, troubleshooting, replacement parts, refurbishing, and the practical help facilities need to keep baling systems productive.', 'thumbnails/ServiceDepartmentPic1.jpg', ['Parts and service support', 'Experienced baler technicians', 'Help for C&M and many existing baling systems']],
  ['baler-refurbishing-services', 'Baler Refurbishing Services', 'Refurbishing can restore balers, improve worn systems, and extend the working life of heavy-duty machinery when a complete replacement is not the best answer.', 'thumbnails/BalingRefurbishingServicesPic1.jpg', ['Structural, hydraulic, and control review', 'Repair and rebuild options', 'A practical path for aging equipment']],
  ['baler-replacement-parts', 'Baler Replacement Parts', 'C&M supplies replacement parts for balers, including components designed around serviceability and off-the-shelf hydraulic availability whenever possible.', 'thumbnails/BalerReplacementPartsPic1.jpg', ['Replacement wear parts', 'Hydraulic and mechanical components', 'Support for standard and custom C&M equipment']],
  ['baling-wire', 'Baling Wire', 'Baling wire support for the tie method, bale size, and baler style used in your operation.', 'equipment/accessories-parts/accessories-parts-1.jpg', ['Wire recommendations by baler style', 'Quote support available', 'Used with manual and automatic tie systems']],
  ['baling-wire-quotation', 'Baling Wire Quotation', 'Request baling wire pricing and share the baler style, material, and operating details needed to recommend the right wire setup.', 'equipment/accessories-parts/accessories-parts-1.jpg', ['Wire quote requests', 'Baler and material details', 'Sales follow-up']],
].map(([slug, title, summary, image, highlights]) => ({ slug, title, summary, image, highlights, section: 'Services' }));

export const companyPages = [
  ['about-us', 'About Us', 'C&M Baling Systems is a privately owned manufacturer in Winston-Salem, North Carolina, with administrative, sales, engineering, and manufacturing facilities on an 8-acre tract of land.', 'thumbnails/AboutUsPic1.jpg', ['Privately owned manufacturer', 'Winston-Salem, North Carolina', 'Quality and safety at the forefront']],
  ['dealers', 'Dealers & Representatives', 'C&M works with factory and dealer representatives to help customers evaluate applications, confirm model selections, and request specification sheets or layout drawings.', 'thumbnails/DealerAndRepsPic1.jpg', ['Factory and dealer support', 'Model selection help', 'Specification and layout assistance']],
  ['sustainability', 'Sustainability', 'C&M baling systems support recycling, waste reduction, reusable material recovery, and denser shipping of materials that would otherwise consume storage and transport space.', 'thumbnails/SustainabilityLeftColumnPic1.jpg', ['Recycling and waste reduction', 'Lower transport burden', 'Better material recovery']],
  ['refurbished', 'Refurbished Balers', 'Refurbished and rebuilt balers can be a practical fit when heavy structures still have useful life and the equipment can be brought back into dependable service.', 'thumbnails/RefurbishedPic1.jpg', ['Used and rebuilt equipment', 'Practical budget path', 'Structural service-life review']],
].map(([slug, title, summary, image, highlights]) => ({ slug, title, summary, image, highlights, section: 'Company' }));

const industryImages = {
  'paper-mills': 'equipment/horizontal-balers/horizontal-8.jpg',
  'corrugated-container-manufacturers': 'equipment/horizontal-balers/horizontal-1.jpg',
  'nonwoven-mills': 'equipment/horizontal-balers/textiles.jpg',
  'textile-mills-cotton-gins': 'equipment/horizontal-balers/textiles.jpg',
  'distribution-centers': 'equipment/horizontal-balers/horizontal-1.jpg',
  'manufacturers-industrial-plants': 'equipment/horizontal-balers/horizontal-7.jpg',
  'warehouses': 'equipment/vertical-balers/vertical-3.jpg',
  'recycling-centers': 'equipment/horizontal-balers/horizontal-5.jpg',
};

export const industryPages = [
  ['paper-mills', 'Paper Mills', 'Paper, trim, and recovered fiber systems built around steady material flow and dense, shippable bales.'],
  ['corrugated-container-manufacturers', 'Corrugated Container Manufacturers', 'Baling and handling for corrugated, box board trim, small cartons, and packaging scrap.'],
  ['nonwoven-mills', 'Nonwoven Mills', 'Specialized baling for non-wovens and fibers where contamination control and platen design matter.'],
  ['textile-mills-cotton-gins', 'Textile Mills & Cotton Gins', 'Cotton, textile, gin trash, biomass, and fiber baling equipment for difficult material streams.'],
  ['distribution-centers', 'Distribution Centers', 'Waste reduction and recycling systems for cardboard, packaging materials, and mixed facility streams.'],
  ['manufacturers-industrial-plants', 'Manufacturers & Industrial Plants', 'Heavy-duty baling and handling equipment for trimmings, by-products, and production waste.'],
  ['warehouses', 'Warehouses', 'Compact baling systems and material handling for lower to medium volume packaging waste.'],
  ['recycling-centers', 'Recycling Centers', 'Horizontal, full-eject, and specialty balers for multiple grades and changing recyclable materials.'],
].map(([slug, title, summary]) => ({
  slug,
  title,
  summary,
  image: industryImages[slug],
  highlights: ['Material-specific recommendations', 'Baler loading and discharge planning', 'Serviceable equipment design'],
  section: 'Industries',
}));

export const allDetailPages = [...products, ...guidePages, ...servicePages, ...companyPages, ...industryPages];

export const sectionItems = (section) => {
  if (section === 'Products') return products;
  if (section === 'Services') return servicePages;
  if (section === 'Selection Guide') return guidePages;
  if (section === 'Industries') return industryPages;
  return companyPages;
};

export const pageImages = {
  'closed-end-manual-tie-balers': [
    'equipment/horizontal-balers/feed-hopper.jpg',
    'equipment/horizontal-balers/feed-wide-mouth.jpg',
    'equipment/horizontal-balers/hopper.jpg',
    'equipment/horizontal-balers/bale-chamber-2.jpg',
  ],
  'open-end-automatic-tie-balers': [
    'equipment/horizontal-balers/horizontal-1.jpg',
    'equipment/horizontal-balers/horizontal-3.jpg',
    'equipment/horizontal-balers/horizontal-2.jpg',
    'equipment/horizontal-balers/horizontal-6.jpg',
    'equipment/horizontal-balers/parallel.jpg',
  ],
  'wide-mouth-open-end-automatic-tie-balers': [
    'equipment/horizontal-balers/horizontal-8.jpg',
    'equipment/horizontal-balers/horizontal-5.jpg',
    'equipment/horizontal-balers/horizontal-1.jpg',
  ],
  'multi-materials-full-eject-closed-end-balers': [
    'equipment/horizontal-balers/hopper.jpg',
    'equipment/compactors/operation.jpg',
    'equipment/compactors/compactor-4.jpg',
    'equipment/compactors/configuration-1.jpg',
    'equipment/compactors/configuration-2.jpg',
    'equipment/compactors/configuration-3.jpg',
  ],
  'open-end-manual-tie-balers': [
    'equipment/horizontal-balers/horizontal-0.jpg',
    'equipment/horizontal-balers/feed-standard.jpg',
    'equipment/horizontal-balers/bale-chamber.jpg',
  ],
  'cart-lifters-dumpers-dump-carts': [
    'equipment/custom-specialty-equipment/custom-specialty-equipment-1.jpg',
    'equipment/horizontal-balers/horizontal-7.jpg',
    'thumbnails/CartLeftColumnPic1.jpg',
    'thumbnails/CartLeftColumnPic3.jpg',
  ],
  'used-clothing-balers': [
    'equipment/horizontal-balers/horizontal-5.jpg',
    'equipment/vertical-balers/vertical-1.jpg',
    'equipment/horizontal-balers/textiles.jpg',
    'equipment/custom-specialty-equipment/custom-specialty-equipment-1.jpg',
  ],
  'cotton-gin-textile-baling-presses': [
    'equipment/horizontal-balers/textiles.jpg',
    'equipment/horizontal-balers/feed-hopper.jpg',
    'equipment/horizontal-balers/horizontal-6.jpg',
    'equipment/horizontal-balers/horizontal-8.jpg',
    'equipment/compactors/operation.jpg',
  ],
  'biomass-cotton-gin-trash-baling-press': [
    'equipment/horizontal-balers/biomass.jpg',
    'thumbnails/BiomassandCottonGinPic1.jpg',
  ],
  'vertical-down-packing-baling-presses-balers': [
    'equipment/vertical-balers/vertical-3.jpg',
    'equipment/vertical-balers/vertical-4.jpg',
    'equipment/vertical-balers/vertical-2.jpg',
    'equipment/vertical-balers/vertical-1.jpg',
    'equipment/vertical-balers/conveyor-fed-vertical-2.jpg',
  ],
  'conveyors-bale-conveying-bagging-systems': [
    'equipment/conveyors-material-handling/conveyor-2.jpg',
    'equipment/conveyors-material-handling/conveyors-material-handling-1.jpg',
    'equipment/conveyors-material-handling/conveyor-1.jpg',
    'equipment/conveyors-material-handling/rubber-belt-1.jpg',
    'equipment/conveyors-material-handling/belt-cleats.jpg',
  ],
  'precrush-compactors-waste-compactors': [
    'equipment/compactors/compactor-1.jpg',
    'equipment/compactors/compactor-2.jpg',
    'equipment/compactors/compactor-3.jpg',
    'equipment/compactors/compactors-1.jpg',
    'equipment/compactors/compactors.jpg',
    'equipment/compactors/stationary-compactor.jpg',
    'equipment/compactors/self-contained-compactor.jpg',
  ],
  'custom-designed-specialty-balers': [
    'equipment/custom-specialty-equipment/custom-specialty-equipment-1.jpg',
    'equipment/horizontal-balers/horizontal-7.jpg',
    'equipment/horizontal-balers/biomass.jpg',
  ],
  'horizontal-manual-tie-balers': [
    'equipment/horizontal-balers/horizontal-0.jpg',
    'equipment/horizontal-balers/feed-hopper.jpg',
    'equipment/horizontal-balers/feed-standard.jpg',
    'equipment/horizontal-balers/feed-wide-mouth.jpg',
    'equipment/horizontal-balers/closed-vs-open.jpg',
  ],
  'horizontal-automatic-tie-balers': [
    'equipment/horizontal-balers/horizontal-3.jpg',
    'equipment/horizontal-balers/horizontal-7.jpg',
    'equipment/horizontal-balers/parallel.jpg',
    'equipment/horizontal-balers/horizontal-6.jpg',
    'equipment/conveyors-material-handling/conveyor-1.jpg',
    'equipment/horizontal-balers/horizontal-2.jpg',
    'equipment/horizontal-balers/auto-tie.jpg',
  ],
  'multi-material-full-eject-balers': [
    'equipment/horizontal-balers/hopper.jpg',
    'equipment/compactors/operation.jpg',
    'equipment/horizontal-balers/closed-vs-open-vs-gate.jpg',
    'equipment/compactors/configuration-3.jpg',
  ],
  'vertical-down-packing-balers': [
    'equipment/vertical-balers/vertical-3.jpg',
    'equipment/vertical-balers/vertical-4.jpg',
    'equipment/vertical-balers/vertical-2.jpg',
    'equipment/vertical-balers/vertical-1.jpg',
    'equipment/vertical-balers/conveyor-fed-vertical-1.jpg',
    'equipment/vertical-balers/conveyor-fed-vertical-2.jpg',
  ],
  'service-department': ['thumbnails/ServiceDepartmentPic1.jpg'],
  'baler-refurbishing-services': [
    'thumbnails/BalingRefurbishingServicesPic1.jpg',
    'thumbnails/BalingRefurbishingServicesPic2.jpg',
  ],
  'baler-replacement-parts': [
    'thumbnails/BalerReplacementPartsPic1.jpg',
    'thumbnails/BalerReplacementPartsPic2.jpg',
    'thumbnails/BalerReplacementPartsLeftColumnPic1.jpg',
    'thumbnails/BalerReplacementPartsLeftColumnPic2.jpg',
  ],
  'baling-wire': [
    'equipment/accessories-parts/accessories-parts-1.jpg',
    'thumbnails/BalingWirePic1.jpg',
    'thumbnails/BalingWirePic2.jpg',
  ],
  'about-us': [
    'thumbnails/AboutUsPic1.jpg',
    'thumbnails/AboutUsLeftColumnPic1.jpg',
  ],
  dealers: [
    'thumbnails/DealerAndRepsPic1.jpg',
    'thumbnails/DealerAndRepsLeftColumnPic1.jpg',
  ],
  sustainability: ['thumbnails/SustainabilityLeftColumnPic1.jpg'],
  refurbished: ['thumbnails/RefurbishedPic1.jpg'],
  'paper-mills': [
    'equipment/horizontal-balers/horizontal-8.jpg',
    'equipment/horizontal-balers/horizontal-6.jpg',
    'equipment/conveyors-material-handling/conveyor-1.jpg',
    'equipment/horizontal-balers/parallel.jpg',
  ],
  'corrugated-container-manufacturers': [
    'equipment/horizontal-balers/horizontal-1.jpg',
    'equipment/horizontal-balers/horizontal-2.jpg',
    'equipment/horizontal-balers/horizontal-3.jpg',
    'equipment/conveyors-material-handling/conveyor-2.jpg',
  ],
  'nonwoven-mills': [
    'equipment/horizontal-balers/textiles.jpg',
    'equipment/compactors/operation.jpg',
    'equipment/horizontal-balers/horizontal-6.jpg',
  ],
  'textile-mills-cotton-gins': [
    'equipment/horizontal-balers/textiles.jpg',
    'equipment/horizontal-balers/biomass.jpg',
    'equipment/horizontal-balers/horizontal-5.jpg',
    'equipment/compactors/operation.jpg',
  ],
  'distribution-centers': [
    'equipment/horizontal-balers/horizontal-1.jpg',
    'equipment/conveyors-material-handling/conveyor-2.jpg',
    'equipment/compactors/precrush-compactor-3.jpg',
    'equipment/vertical-balers/vertical-3.jpg',
  ],
  'manufacturers-industrial-plants': [
    'equipment/horizontal-balers/horizontal-7.jpg',
    'equipment/custom-specialty-equipment/custom-specialty-equipment-1.jpg',
    'equipment/horizontal-balers/hopper.jpg',
    'equipment/compactors/precrush-compactor.jpg',
  ],
  warehouses: [
    'equipment/vertical-balers/vertical-3.jpg',
    'equipment/vertical-balers/vertical-4.jpg',
    'equipment/horizontal-balers/feed-hopper.jpg',
    'equipment/accessories-parts/accessories-parts-1.jpg',
  ],
  'recycling-centers': [
    'equipment/horizontal-balers/horizontal-5.jpg',
    'equipment/horizontal-balers/hopper.jpg',
    'equipment/compactors/compacted-bales.jpg',
    'equipment/conveyors-material-handling/rubber-belt-2.jpg',
  ],
};

export const pageSections = {
  'closed-end-manual-tie-balers': [
    {
      heading: 'Horizontal Closed-End Semi-Automatic Balers',
      paragraphs: [
        'C&M closed-end manual tie balers use vertical in-feed chutes with 30 inch wide or extra wide-mouth 42 inch and 46 inch hopper options, 3-1/2 sided hoppers, cart dumping systems, pre-press chambers, and other application-driven features.',
        'Medium-duty and extra heavy-duty models are configured for industrial and commercial baling of paper, corrugated, packaging waste, production scrap, textiles, plastics, and other recyclable or disposable materials.',
      ],
      bullets: ['Vertical in-feed chute arrangements', 'Manual wire or strap tying while the bale is held in the chamber', 'Common low-cost choice for lower and medium production'],
    },
    {
      heading: 'Standard Manual Tie Model Range',
      paragraphs: [
        'C&M single ram manual tie models are selected by infeed opening, bale size, compression cylinder bore, motor horsepower, and platen force. Selection depends on the opening needed for the material, expected throughput, compression resistance, and the target bale package.',
      ],
      bullets: ['30 inch standard and 42/46 inch wide-mouth openings', 'Medium-duty through extra heavy-duty structures', 'Options for cart dumping, pre-pressing, and special hoppers'],
    },
  ],
  'baling-wire-quotation': [
    {
      heading: 'Baling Wire Quotation Request',
      paragraphs: [
        'C&M collects wire type, quantity, baler style, and usage details so the team can respond with an accurate baling wire quotation.',
        'The wire quotation request is available as a dedicated contact tab alongside general inquiries, baler quote requests, and the questionnaire.',
      ],
      bullets: ['Wire type and quantity request', 'Baler style and material context', 'Quote flow merged into the modern contact hub'],
    },
  ],
  'open-end-automatic-tie-balers': [
    {
      heading: 'Automatic Tie Production',
      paragraphs: [
        'Automatic tying horizontal open-end balers are built for medium and high production baling of paper, paper trim, trimmed or shredded corrugated, box board trim, small cartons, non-wovens, fiberglass, aluminum beverage containers, and industrial trimmings or by-products.',
        'C&M emphasizes a dependable wire inserting and tying mechanism with an independent electric and hydraulic system so adjustments and servicing stay practical.',
      ],
      bullets: ['Auto wire insertion, cutting, and twisting', 'Open-end extrusion chamber for continuous bale production', 'Independent tie system integrated with PLC controls'],
    },
    {
      heading: 'When It Fits',
      paragraphs: [
        'Automatic tie balers are commonly recommended when the material stream is steady, operator time is limited, or production volume is high enough that manual tying becomes the bottleneck.',
      ],
      bullets: ['Paper mills and converting plants', 'Corrugated and box board trimming systems', 'Recycling and industrial by-product streams'],
    },
  ],
  'wide-mouth-open-end-automatic-tie-balers': [
    {
      heading: 'Wide-Mouth Automatic Baling',
      paragraphs: [
        'Wide-mouth automatic tying horizontal open-end balers are intended for larger materials such as computer and equipment boxes, fiberglass sheeting, bulk materials, loose paper, OCC, and recyclables at recovery facilities, paper mills, distribution centers, manufacturing plants, and repackaging centers.',
        'Consistently sized large heavy bales are automatically tied and ejected with PLC controlled baler function sequencing. For single-stream materials, these fast wide-mouths can out-produce many two-ram balers.',
      ],
      bullets: ['Large hopper openings for bulky loads', 'Automatic tying and ejection', 'Extra heavy-duty configurations for extreme usage'],
    },
  ],
  'multi-materials-full-eject-closed-end-balers': [
    {
      heading: 'Full-Eject Multi-Material Baling',
      paragraphs: [
        'C&M full-eject horizontals are available in several models and styles for different materials. After the bale tie wires are manually inserted and locked, the completed bale is pushed fully out of the chamber.',
        'That complete ejection makes these balers valuable for multi-grade recycling because each bale can be separated cleanly before the next material is processed.',
      ],
      bullets: ['Excellent for changing grades and difficult materials', 'Common choice for cotton, textiles, films, foam, fiberglass, and shredded carpet', 'Designed when complete bale separation matters'],
    },
    {
      heading: 'Selection Tradeoff',
      paragraphs: [
        'Full-eject balers cost more than comparable closed-end manual tie machines, but they can solve applications where standard closed-end balers struggle with springback, slick material, bale discharge, or contamination between grades.',
      ],
    },
  ],
  'open-end-manual-tie-balers': [
    {
      heading: 'Manual Tie Open-End Balers',
      paragraphs: [
        'Manual tie horizontal open-end balers provide a lower cost answer for low and medium production baling of paper, paper trim, corrugated and box board trim, non-wovens, aluminum beverage containers, and industrial trimmings or by-products.',
        'This style keeps the open-end extrusion chamber advantage while the operator manually inserts and locks the bale ties.',
      ],
      bullets: ['Lower labor than many closed-end manual tie applications', 'Useful where automatic tying is not required', 'Good fit for steady but moderate material flow'],
    },
  ],
  'cart-lifters-dumpers-dump-carts': [
    {
      heading: 'Cart Loading Systems',
      paragraphs: [
        'C&M cart lifters and dumpers are used to collect and transport production materials or waste, then unload carts into balers, conveyors, compactors, shredders, or other receiving equipment with less manual handling.',
        'Systems can be integrated with a C&M baler hydraulic power unit or supplied with an independent hydraulic power package, with safety guards and interlocks built into the design.',
      ],
      bullets: ['CM30, CM34, CM50, CM60, and CM78 dumping systems', 'Double-acting hydraulic cylinders and guarded dumping cycles', 'Steel and molded plastic cart options'],
    },
  ],
  'used-clothing-balers': [
    {
      heading: 'Used Clothing and Textile Material',
      paragraphs: [
        'Used clothing and textile baling applications often involve difficult fiber springback, manual sorting, changing grades, and bale handling requirements that shape the baler recommendation.',
        'C&M commonly approaches these applications through full-eject or specialty baler configurations when clean separation, bale removal, or dense package consistency is more important than a standard low-cost baler.',
      ],
      bullets: ['Used clothing and textile recycling', 'Springy or high-memory materials', 'Manual sorting and multiple-grade workflows'],
    },
  ],
  'cotton-gin-textile-baling-presses': [
    {
      heading: 'Cotton, Textile, and Fiber Baling',
      paragraphs: [
        'C&M baling presses are used for cotton, tobacco, textile goods, manmade fibers, natural fibers, and other specialized materials where bale shape, contamination control, and compression behavior matter.',
        'The equipment can be configured with special compression platens, hopper arrangements, and discharge handling for the material and the package expected by storage or shipping.',
      ],
      bullets: ['Cotton and textile fiber applications', 'Natural and manmade fiber handling', 'Specialty platen and bale handling options'],
    },
  ],
  'biomass-cotton-gin-trash-baling-press': [
    {
      heading: 'C&M2424EC Biomass Press',
      paragraphs: [
        'The C&M2424EC Series cotton gin trash and biomass baling press was developed after more than fifteen years of testing and trials for baling organic waste from cotton ginning and cotton mote processing.',
        'The press is described with a 40 HP hydraulic power unit, fully wired electrical box, independent PLC controlled operator panel, and simple touchscreen interface.',
      ],
      bullets: ['Bales cotton gin waste, bagasse, Miscanthus, and other energy crops', 'Reported bale density of roughly 29 to 34 pounds per cubic foot', 'Dense bales for storage, handling, and transport'],
    },
  ],
  'vertical-down-packing-baling-presses-balers': [
    {
      heading: 'Vertical and Down-Packing Presses',
      paragraphs: [
        'Vertical down-stroke balers are common because of their lower initial cost and versatility for lower volumes of cardboard, paper, and packaging material.',
        'C&M also builds heavy-duty specialty vertical down-packing presses with rear loading chutes, hydraulic bale eject, high compression force, custom bale sizes, and options such as tie-through front doors or photo-eye controls.',
      ],
      bullets: ['Common mill-size bales around 60 x 30 x 48 inches', '5 HP to 15 HP power packages depending on model', 'Specialty rear-feed and bale-eject configurations'],
    },
  ],
  'conveyors-bale-conveying-bagging-systems': [
    {
      heading: 'Material Handling Around the Baler',
      paragraphs: [
        'Conveyors increase material handling efficiency by moving scrap, trim, broke, cartons, and finished bales into and out of the baling system. C&M offers hinged steel belt conveyors, sliderbed belt conveyors, powered roller conveyors, gravity roller conveyors, and specialty conveyors.',
        'Conveyors can be incorporated into the C&M operator control system and hydraulic system so the baler and handling equipment operate as one coordinated production system.',
      ],
      bullets: ['Pit conveyors and incline loading conveyors', 'Sliderbed and hinged steel belt conveyors', 'Bale take-away, bagging, and downstream handling'],
    },
  ],
  'precrush-compactors-waste-compactors': [
    {
      heading: 'PreCrush Waste Compaction',
      paragraphs: [
        'C&M PreCrush compactors are used where bulky waste needs to be broken down before final compaction into the container. The purpose is simple: load more waste per haul and reduce paid trips to disposal or landfill.',
        'These systems are application-specific, especially when large boxes, pallets, packaging, manufacturing waste, or irregular bulky material would otherwise bridge or spring back in a standard compactor.',
      ],
      bullets: ['Pre-crushes bulky material before final compaction', 'Improves container payloads', 'Built for tough industrial waste streams'],
    },
  ],
  'custom-designed-specialty-balers': [
    {
      heading: 'Custom Baler Examples',
      paragraphs: [
        'C&M custom designs include open-end manual tie baling presses with tall chutes, fixed density controls, attached bale bagging systems, and spring-loaded roller conveyors for bales that need specific density, weight, length, and bagging requirements.',
        'Another example is a heavy-duty closed-end full-eject manual tie horizontal baler with cart lifter, material tramper, plastics option, 40 HP PLC controlled hydraulic power unit, and remote operator panel for very slick, difficult-to-bale plastics.',
      ],
      bullets: ['Custom chute, density, bagging, and discharge requirements', 'Specialized cart lifter and tramper systems', 'Timed-cycle in-feed prepress options for light material'],
    },
  ],
  'horizontal-manual-tie-balers': [
    {
      heading: 'Manual Tie Selection Guide',
      paragraphs: [
        'C&M describes three horizontal single ram manual tie styles: closed-end, open-end, and full-eject. They are called manual tie because the operator inserts and locks wire or straps while the bale is held inside the chamber.',
        'Closed-end models are typically the lowest cost, open-end models are often better for materials with excessive memory, and full-eject models handle the most difficult or multiple material types.',
      ],
      bullets: ['Often 1,000 to 5,000 pounds per hour depending on material and loading', 'Horizontal loading requires much less manual labor than vertical loading', 'Baler style depends on material memory, volume, and operator time'],
    },
  ],
  'horizontal-automatic-tie-balers': [
    {
      heading: 'Automatic Tie Selection Guide',
      paragraphs: [
        'Automatic tie balers are open-end extrusion chamber machines where wires are pulled from spools, inserted, cut, and twisted by the automatic tie system attached to the heavy-duty baler frame.',
        'Automatic tie is recommended when a regular baler operator is not available or when material volume commonly exceeds about three tons per hour.',
      ],
      bullets: ['Continuous extrusion of tied bales', 'PLC controlled baler and tie system integration', 'Can operate in back-room applications when material enters the hopper'],
    },
  ],
  'multi-material-full-eject-balers': [
    {
      heading: 'Full-Eject Selection Guide',
      paragraphs: [
        'Full-eject balers are recommended for multi-grade recycling and difficult materials because the finished bale is fully pushed out after tying. That gives clean separation before the next grade enters the chamber.',
        'The guide ties these machines to cotton and textile fibers, thin slick films, shredded carpet material, foam rubber, fiberglass, and other springy or slippery materials.',
      ],
      bullets: ['Clean separation between grades', 'Useful for hard-to-eject materials', 'Often selected when standard closed-end baling is unreliable'],
    },
  ],
  'vertical-down-packing-balers': [
    {
      heading: 'Vertical Baler Selection Guide',
      paragraphs: [
        'Vertical down-stroke balers are the most common baler style because they are comparatively low cost and versatile for lower volumes of cardboard, paper, and packaging.',
        'The guide also explains that C&M heavy-duty specialty vertical down-packing balers can include rear loading chutes, hydraulic bale eject, high compression, and custom bale sizes when standard vertical balers are not enough.',
      ],
      bullets: ['Common 60 x 30 x 48 to 50 inch bale package', 'Common 5 HP, 10 HP, and 15 HP power units', 'Specialty models for heavier compression needs'],
    },
  ],
  'service-department': [
    {
      heading: 'Service and Support',
      paragraphs: [
        'C&M supports customers with baler service, troubleshooting, replacement parts, refurbishing, and practical help for keeping existing baling systems productive.',
        'Factory field service for C&M products can be scheduled through the service department or by email at service@baling.com. Qualified C&M dealers can provide high-quality repair services with active online C&M support.',
        'In certain areas, C&M factory technicians or dealer technicians can service most any brand of baler or waste compactor. If C&M cannot handle a service request directly, the team can forward it to a qualified dealer or trade associate.',
      ],
      bullets: ['Replacement part support', 'Refurbishing and rebuild guidance', 'Factory help for C&M balers and related systems'],
    },
  ],
  'baler-refurbishing-services': [
    {
      heading: 'Refurbishing Heavy Equipment',
      paragraphs: [
        'Refurbishing can be a practical answer when a heavy baler frame still has useful life but hydraulic, electrical, safety, or wear components need attention.',
        'C&M can review the machine condition and application, then determine whether repair, rebuild, or replacement is the better path.',
      ],
      bullets: ['Structural, hydraulic, and electrical review', 'Wear component replacement', 'Practical option for aging heavy-duty machines'],
    },
  ],
  'baler-replacement-parts': [
    {
      heading: 'Replacement Parts',
      paragraphs: [
        'When replacement parts are required, the C&M Parts Department can provide most components for your baling press, including hydraulic system valves, pumps, filters, pressure switches, new compression or door cylinders, electrical parts, PLC controllers, motor starters, disconnects, fuses, and push buttons.',
        'C&M also supports Banner material level photo sensors, SONAC sensors, auto-tie wear parts such as wire twisters, wire rollers and guides, standard and serrated shear blades, material retention dogs or springs, cylinder repacking kits, ram wear strips, and cut-to-fit abrasive resistant steel plate for relining baler floors or rams.',
      ],
      bullets: ['Hydraulic system valves, pumps, filters, and switches', 'Compression cylinders, door cylinders, and repacking kits', 'Electrical components, PLCs, starters, disconnects, fuses, and push buttons'],
    },
    {
      heading: 'Parts Department Support',
      paragraphs: [
        'Replacement or spare wear parts, quick-lock wire, single loop baling wire, and factory or field repair services are available as needed. Expedited and special order parts can be shipped by contacting the parts department at (336) 723-4869, (800) 225-3796, or parts@baling.com.',
        'C&M replacement parts are competitively priced and promptly shipped by experienced parts department staff.',
      ],
    },
  ],
  'baling-wire': [
    {
      heading: 'Baling Wire Support',
      paragraphs: [
        'Baling wire selection depends on the baler style, tying method, bale size, material type, and operating volume. C&M captures wire type and quantity so the team can quote the correct wire for the customer\'s operation.',
        'In the remake, the baling wire quotation remains available as a tab inside the merged contact page, keeping the same information but placing it in a cleaner modern form flow.',
      ],
      bullets: ['Manual and automatic tie wire needs', 'Quote by wire type and quantity', 'Baler and material context requested'],
    },
  ],
  'about-us': [
    {
      heading: 'C&M Baling Systems',
      paragraphs: [
        'C&M Baling Systems is a privately owned manufacturer located in Winston-Salem, North Carolina. The company operates administrative, sales, engineering, and manufacturing facilities on an 8-acre tract of land.',
        'Quality and safety are at the forefront as C&M designs and manufactures baling presses and material handling equipment for industrial and commercial users.',
      ],
      bullets: ['Privately owned manufacturer', 'Winston-Salem, North Carolina', 'Administrative, sales, engineering, and manufacturing in one operation'],
    },
    {
      heading: 'Business Philosophy',
      paragraphs: [
        'Owners and employees at C&M have a passion to design, fabricate, and assemble balers. Standard and custom baler designs are produced with practical service access, industrial duty cycles, and safety in mind.',
        'Production lead-time for finished balers or related machinery and equipment is usually eight to ten weeks, depending on configuration and current production schedule.',
      ],
    },
    {
      heading: 'Manufacturing Approach',
      paragraphs: [
        'C&M builds strong baling presses from structural steel. Steel plate is cut, welded into primary structures, fitted with hoppers and guarding, assembled with hydraulic and electrical systems, tested, cleaned, and painted before shipment.',
        'C&M emphasizes heavy structures, hydraulic and electrical serviceability, and a willingness to configure machinery around material type, loading method, bale requirements, and available facility space.',
      ],
    },
  ],
  sustainability: [
    {
      heading: 'Sustainability Through Practical Recovery',
      paragraphs: [
        'C&M frames sustainability as making the best use of available resources while improving operational efficiency.',
        'C&M baling systems support recycling and waste reduction by turning loose material into denser, more manageable bales for storage, shipping, reuse, or sale.',
      ],
      bullets: ['More efficient material handling', 'Denser shipments and reduced storage burden', 'Support for recyclable and reusable material streams'],
    },
    {
      heading: 'Less Loose Material, More Recoverable Value',
      paragraphs: [
        'Baling reduces loose material volume, improves storage density, and helps facilities prepare recyclable paper, corrugated, textiles, plastics, biomass, and non-ferrous material streams for reuse or sale.',
        'When material grades need to stay separated, the right baler style and handling layout can support cleaner recovery without making the daily workflow more complicated.',
      ],
    },
    {
      heading: 'Serviceable Equipment Life',
      paragraphs: [
        'C&M pairs sustainability with durability: heavy structures, replaceable wear areas, and standard hydraulic components help extend equipment life and keep recovery systems productive.',
      ],
    },
  ],
  dealers: [
    {
      heading: 'Dealers and Representatives',
      paragraphs: [
        'C&M works with factory and dealer representatives to help customers evaluate applications, request product information, and identify suitable baling or handling equipment.',
        'Good dealer conversations start with material type, volume, feeding method, available space, power, desired bale size, and downstream handling requirements.',
      ],
      bullets: ['Application review', 'Model and option selection', 'Specification and layout support'],
    },
  ],
  refurbished: [
    {
      heading: 'Refurbished and Used Balers',
      paragraphs: [
        'C&M presents used balers and rebuild opportunities where the heavy structure can be evaluated for another working life.',
        'A refurbished machine can be a practical budget path when the frame, chamber, and major structure remain sound and the application does not require a newly built custom system.',
      ],
      bullets: ['Used C&M baler opportunities', 'Factory review of condition and application', 'Repair, rebuild, or upgrade possibilities'],
    },
  ],
  'paper-mills': [
    {
      heading: 'Paper Mill Baling Applications',
      paragraphs: [
        'C&M balers are used for paper mill broke, paper trim, tissue trim, tissue logs, slab waste, and recovered fiber streams that need dependable transfer into dense, shippable bales.',
        'C&M conveyor examples include pit conveyors and sliderbed conveyors feeding tissue broke, tissue donuts, tissue logs, slab waste, and trim into horizontal automatic tie balers.',
      ],
      bullets: ['Paper trim and broke handling', 'Conveyor-fed automatic tie systems', 'Dense bales for storage and shipment'],
    },
  ],
  'corrugated-container-manufacturers': [
    {
      heading: 'Corrugated and Box Board Trim',
      paragraphs: [
        'C&M open-end automatic tie balers are frequently described for trimmed or shredded corrugated, box board trim, small cartons, and packaging production scrap.',
        'Wide-mouth automatic balers are useful when boxes or bulk OCC need larger infeed openings and consistent automatic bale discharge.',
      ],
      bullets: ['OCC and box board trim', 'Small cartons and packaging scrap', 'Wide-mouth automatic options for bulky material'],
    },
  ],
  'nonwoven-mills': [
    {
      heading: 'Nonwoven Mill Material',
      paragraphs: [
        'C&M identifies non-wovens as a key material for both manual tie and automatic tie horizontal balers.',
        'C&M recommendations for nonwoven applications depend on the material memory, loading method, desired bale size, and whether the plant needs automatic tying or manual grade separation.',
      ],
      bullets: ['Non-wovens and fiber-like production scrap', 'Manual or automatic tie options', 'Selection based on memory and compression behavior'],
    },
  ],
  'textile-mills-cotton-gins': [
    {
      heading: 'Textiles, Cotton, and Gin Trash',
      paragraphs: [
        'C&M product pages cover cotton, tobacco, textile goods, manmade fibers, natural fibers, used clothing, cotton gin trash, and biomass applications.',
        'Full-eject and specialty balers are often the right discussion when fibers, clothing, films, or springy materials need clean bale ejection and consistent handling.',
      ],
      bullets: ['Cotton and textile fiber handling', 'Used clothing and apparel recycling', 'Cotton gin trash and biomass baling'],
    },
  ],
  'distribution-centers': [
    {
      heading: 'Distribution Center Waste Streams',
      paragraphs: [
        'Distribution centers commonly handle cardboard, packaging, small cartons, pallet-area scrap, and mixed recyclable material that benefits from organized collection, conveying, and baling.',
        'C&M systems can combine cart dumpers, conveyors, horizontal balers, vertical balers, and compactors depending on volume, labor availability, and floor space.',
      ],
      bullets: ['Cardboard and packaging waste', 'Cart dumping and conveyor loading', 'Baling and compacting to reduce hauling and storage burden'],
    },
  ],
  'manufacturers-industrial-plants': [
    {
      heading: 'Industrial Plant By-Products',
      paragraphs: [
        'C&M product applications include industrial trimmings and by-products across open-end automatic, open-end manual, and custom designed balers.',
        'C&M can tailor infeed openings, hoppers, tramper systems, hydraulic packages, and discharge methods when a standard baler does not fit the material stream.',
      ],
      bullets: ['Industrial trimmings and by-products', 'Custom hoppers and infeed systems', 'Heavy-duty baler frames for demanding environments'],
    },
  ],
  warehouses: [
    {
      heading: 'Warehouse Baling Needs',
      paragraphs: [
        'Warehouses often need practical equipment for lower to medium volume cardboard, paper, and packaging streams without overcomplicating the workflow.',
        'Depending on volume, C&M can point customers toward vertical down-stroke balers, closed-end manual tie balers, cart handling, or compactors.',
      ],
      bullets: ['Lower and medium volume packaging waste', 'Vertical or horizontal baler selection', 'Simple serviceable equipment layouts'],
    },
  ],
  'recycling-centers': [
    {
      heading: 'Recycling Center Grade Separation',
      paragraphs: [
        'Recycling centers often process changing materials and multiple grades, which is why C&M full-eject balers are emphasized for 100 percent bale separation.',
        'Open-end manual, automatic tie, conveyors, and full-eject machines can be combined depending on grade count, material memory, throughput, and bale handling needs.',
      ],
      bullets: ['Multiple recyclable grades', 'Full-eject separation between materials', 'Conveyor and bale handling integration'],
    },
  ],
};
